<template>
  <q-table
    :data="mappedQuotes"
    :columns="columns"
    :pagination.sync="pagination"
    :rows-per-page-options="rowsPerPageOptions"
    row-key="id"
    table-class="invoice-table"
    hide-header
    hide-bottom
    binary-state-sort
  >
    <q-td slot="body-cell-quote_number" slot-scope="props" :props="props">
      <router-link
        v-if="props.row.status.value !== 'draft'"
        :to="{ name: 'quote',  params: { quote: props.row.id, teamId: activeTeam.id } }"
        class="router-link"
      >
        {{ props.row.quote_number }}
      </router-link>

      <router-link
        v-else
        :to="{ name: 'edit-quote',  params: { quote: props.row.id, teamId: activeTeam.id } }"
        class="router-link"
      >
        {{ $t('draft') }}
      </router-link>
    </q-td>

    <q-td slot="body-cell-created_at" slot-scope="props" :props="props">
      <span>
        {{ props.row.created_at_text }}

        <q-tooltip anchor="top middle" self="bottom middle" :delay="300" :offset="[0, 5]">
          {{ props.row.created_at_date }}
        </q-tooltip>
      </span>
    </q-td>

    <q-td slot="body-cell-status" slot-scope="props" :props="props">
      <StatusChip
        :color="props.row.status.color"
        :status="props.row.status.value"
        :committed="props.row.committed_at !== null"
      />
    </q-td>

    <q-td slot="body-cell-actions" slot-scope="props" :props="props">
      <q-btn icon="more_vert" color="grey-7" flat round dense>
        <q-popover>
          <q-list link class="no-border">
            <q-item
              v-if="props.row.status.value !== 'draft'"
              v-close-overlay
              @click.native="$router.push({ name: 'quote', params: { team: activeTeam.id, quote: props.row.id } })"
            >
              <q-item-side icon="visibility"/>
              <q-item-main :label="$t('display')"/>
            </q-item>

            <q-item
              v-if="props.row.committed_at === null"
              v-close-overlay
              @click.native="$router.push({ name: 'edit-quote', params: { team: activeTeam.id, quote: props.row.id } })"
            >
              <q-item-side icon="edit"/>
              <q-item-main :label="$t('edit')"/>
            </q-item>

            <q-item
              v-if="props.row.status.value !== 'draft'"
              v-close-overlay
              @click.native="$router.push({
                name: 'create-invoice',
                params: { team: activeTeam.id  },
                query: { quote: props.row.id }
              })"
            >
              <q-item-side icon="receipt"/>
              <q-item-main :label="$t('create_invoice')"/>
            </q-item>

            <q-item
              v-if="props.row.status.value !== 'draft'"
              v-close-overlay
              @click.native="handlePdfDownload(props.row.id, props.row.quote_number)"
            >
              <q-item-side icon="cloud_download"/>
              <q-item-main :label="$t('download_pdf')"/>
            </q-item>

            <q-item
              v-close-overlay
              v-is-user
              @click.native="handleCopy(props.row)"
            >
              <q-item-side icon="file_copy"/>
              <q-item-main :label="$t('duplicate')"/>
            </q-item>

            <template v-if="props.row.committed_at === null && props.row.status.value !== 'draft'">
              <q-item-separator/>

              <q-item
                v-close-overlay
                v-is-user
                @click.native="handleCommit(props.row)"
              >
                <q-item-side icon="lock"/>
                <q-item-main :label="$t('commit')"/>
              </q-item>
            </template>
          </q-list>
        </q-popover>
      </q-btn>
    </q-td>
  </q-table>
</template>

<script>
  import { defaultColumns, defaultMapFunction } from './defaults'
  import FileSaver from 'file-saver'
  import { QuoteClient } from 'src/api/Quotes'
  import StatusChip from 'components/Quotes/StatusChip'
  import { mapGetters } from 'vuex'
  import { tables } from 'src/config'

  export default {
    components: { StatusChip },
    data () {
      return {
        pagination: {
          page: 1,
          rowsPerPage: 0,
          descending: true,
          sortBy: 'quote_number'
        },
        rowsPerPageOptions: tables.default_rows_per_page_options
      }
    },

    computed: {
      ...mapGetters(['activeTeam']),

      mapFunction () {
        return this.mapFunctionOverride ? this.mapFunctionOverride : defaultMapFunction
      },

      columns () {
        return this.columnsOverride ? this.columnsOverride : defaultColumns
      },

      mappedQuotes () {
        return this.mapFunction(this.quotes)
      }
    },

    methods: {
      handlePdfDownload (quoteId, name) {
        new QuoteClient()
          .pdf(quoteId)
          .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' })
            FileSaver.saveAs(blob, this.$tc('quote', 1) + '_' + name + '.pdf')
          })
      },

      handleCopy (quote) {
        this.$router.push({
          name: 'create-quote',
          params: { team: this.activeTeam.id },
          query: { copy: quote.id }
        })
      }
    },

    props: {
      quotes: {
        required: true,
        type: Array
      },

      columnsOverride: {
        required: false,
        type: Array,
        default: null
      },

      mapFunctionOverride: {
        required: false,
        type: Function,
        default: null
      }
    }
  }
</script>
